import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Router, NavigationEnd, RouterModule } from '@angular/router';
import { map } from 'rxjs/operators';
import { AsyncPipe } from '@angular/common';

import { EventService } from '../../core/services/event.service';
import { SubscriptionStateService } from '../../core/services/subscription-state.service';
import { RightsidebarComponent } from '../rightsidebar/rightsidebar.component';
import { FooterComponent } from '../footer/footer.component';
import { TopbarComponent } from '../topbar/topbar.component';
import { SidebarComponent } from '../sidebar/sidebar.component';
import { NotificationBannerComponent } from '../../shared/components/notification-banner/notification-banner.component';
import { TrialBannerComponent } from '../../shared/components/trial-banner/trial-banner.component';
import { ServiceBillingBannerComponent } from '../../shared/components/service-billing-banner/service-billing-banner.component';
import { ImpersonationBannerComponent } from '../../shared/components/impersonation-banner/impersonation-banner.component';

// import { SIDEBAR_TYPE } from "../layouts.model";

@Component({
  selector: 'app-vertical',
  templateUrl: './vertical.component.html',
  styleUrls: ['./vertical.component.scss'],
  imports: [RouterModule, AsyncPipe, RightsidebarComponent, FooterComponent, TopbarComponent, SidebarComponent, NotificationBannerComponent, TrialBannerComponent, ImpersonationBannerComponent, ServiceBillingBannerComponent]
})

/**
 * Vertical component
 */
export class VerticalComponent implements OnInit, AfterViewInit {

  isCondensed: any = false;
  sidebartype: string;

  readonly showBanner$ = this.subscriptionState.state$.pipe(
    map(s => s.isTrial || s.isGrace || s.isBlocked || s.status === 'payment_failed' ||
      (s.congregationSize !== null && s.limits?.maxCongregationSize != null &&
        s.congregationSize >= s.limits.maxCongregationSize))
  );

  constructor(private router: Router, private eventService: EventService, private subscriptionState: SubscriptionStateService) {
    this.router.events.forEach((event) => {
      if (event instanceof NavigationEnd) {
        document.body.classList.remove('sidebar-enable');
      }
    });
  }

  ngOnInit() {
    document.body.setAttribute('data-layout', 'vertical');
  }

  isMobile() {
    const ua = navigator.userAgent;
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i.test(ua);
  }

  ngAfterViewInit() {
  }

  /**
   * on settings button clicked from topbar
   */
  onSettingsButtonClicked() {
    document.body.classList.toggle('right-bar-enabled');
  }

  /**
   * On mobile toggle button clicked
   */
  onToggleMobileMenu() {
    this.isCondensed = !this.isCondensed;
    document.body.classList.toggle('sidebar-enable');
    document.body.classList.toggle('vertical-collpsed');

    if (window.screen.width <= 768) {
      document.body.classList.remove('vertical-collpsed');
    }
  }
}
